import { render, staticRenderFns } from "./OzOverlay.vue?vue&type=template&id=697dc245&scoped=true&"
import script from "./OzOverlay.vue?vue&type=script&lang=ts&setup=true&"
export * from "./OzOverlay.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./OzOverlay.vue?vue&type=style&index=0&id=697dc245&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697dc245",
  null
  
)

export default component.exports